import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalEditRole, setSelectedRoleId }) {
  // const handleDelete = (item) => event => {
  //     history.push({ pathname: "/roles", state: { id: '11', name:'jjj' , persianName:'hhh' } });
  // };
  const columns = useMemo(
    () => [
      {
        accessor: "_id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "name",
        Header: "نام لاتین نقش",
        minWidth: "100px",
      },
      {
        accessor: "persianName",
        Header: "نام فارسی نقش",
        minWidth: "100px",
      },
      // {
      //     accessor: "created",
      //     Header: '"زمان ایجاد"',
      //     minWidth: '100px',
      // },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* مشاهده */}
            {/* <button
                            className="btn btn-light-info btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-eye text-small'></i>
                        </button> */}

            {/* ویرایش */}
            <Button
              title="ویرایش"
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              onClick={(e) => {
                setSelectedRoleId(row.original.id);
                setShowModalEditRole(true);
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>
          </div>
        ),

        // Cell: ({ row }) => (
        //     <div className="text-center">
        //         {/* ویرایش */}
        //         <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/userWithdrawalsDetails/${row.original.id}`}   >
        //             <i className='far fa-edit text-small'></i>
        //         </Link>
        //     </div>
        // )
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
